module.exports = __webpack_public_path__ + "media/assets/directory-cbd4b8950b812f8e6b0b698fbf1ab425.svg";